import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  TemplateRef,
  ViewChild,
  Inject,
  Renderer2,
  inject,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';
import { FormArray } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbCalendar, NgbDate, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { AlertMsgModel, ResultLinkObject } from '../../../interfaces';
import { FlightSearchService } from '../../../services/flight-search/services/flight-search.service';
import { HomePageService } from '../../../services/home-page/services/home-page.service';
import { PopularAirlinesSharedService } from '../../../../components/popular-airlines/services/popular-airlines-shared.service';
import { Airport, SharedService } from '../../../services/shared.service';
import Swal from 'sweetalert2';
import {
  Subject,
  debounceTime,
  distinctUntilChanged,
  finalize,
  retry,
  switchMap,
} from 'rxjs';
import { FlightSearchApiService } from '../../../services/flight-search/services/flight-search-api.service';
import { StorageService } from '../../../services/storage-services.service';
import { IAirPortTranslated } from '../../../../components/popular-airlines/models/airlineInfo.models';
@Component({
  selector: 'app-one-way',
  templateUrl: './one-way.component.html',
  styleUrls: ['./one-way.component.scss'],
})
export class OneWayComponent implements OnInit {
  private isBrowser: boolean;

  searchbox = inject(FlightSearchService);
  homePageService = inject(HomePageService);
  translate = inject(TranslateService);
  sharedService = inject(SharedService);
  router = inject(Router);
  flightSearchApi = inject(FlightSearchApiService);
  private modalService = inject(NgbModal);
  sharedAirlineService = inject(PopularAirlinesSharedService);
  searchInput$ = new Subject<string>();
  public screenWidth: number = 650;

  @ViewChild('mobileIssuedCountryDepart')
  mobileIssuedCountryDepart!: ElementRef;
  @ViewChild('mobileIssuedCountryLanding')
  mobileIssuedCountryLanding!: ElementRef;
  @ViewChild('departInput') departInput!: ElementRef;
  @ViewChild('landingInput') landingInput!: ElementRef;

  isSearching: boolean = false;
  showDatePicker: boolean = true;
  lang: string = 'en';
  startDateValue: any;
  endDateValue: Date = new Date(2023, 9, 30);
  currency?: string;
  minDate!: NgbDate;
  hoveredDate: NgbDate | null = null;
  isLoading: boolean = false;

  @ViewChild('oneWayCalenderTrigger')
  oneWayCalenderTrigger!: ElementRef;

  resultLink?:
    | string
    | {
        adult: AlertMsgModel;
        child: AlertMsgModel;
        infant: AlertMsgModel;
        retDate: AlertMsgModel;
        depDate: AlertMsgModel;
      };
  selectedValue?: string;
  adultValid: boolean = true;
  childValid: boolean = true;
  infantValid: boolean = true;
  openClass: boolean = false;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private renderer: Renderer2,
    public calendar: NgbCalendar,
    private storageService: StorageService,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    this.minDate = this.calendar.getToday();
  }

  ngOnInit(): void {
    if (this.isBrowser) {
      this.initializeBrowserLogic();
    }
  }

  private initializeBrowserLogic(): void {
    this.sharedService.cities = [
      ...this.sharedService.initialRecommendedAirports,
    ];
    this.searchInput$
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        switchMap((searchTerm) => {
          this.isLoading = true;
          this.sharedService.cities = [];
          return this.flightSearchApi.getSearchFlowMapping(searchTerm).pipe(
            retry(3),
            finalize(() => {
              this.isLoading = false;
            }),
          );
        }),
      )
      .subscribe({
        next: (results) => {
          this.sharedService.cities = results;
        },
        error: (err) => {
          console.error('API error:', err);
          this.isLoading = false;
        },
      });
    if (isPlatformBrowser(this.platformId)) {
      this.screenWidth = window.innerWidth;
    }
  }

  isHovered(date: NgbDate) {
    return (
      this.startDateValue &&
      date.after(this.startDateValue) &&
      date.before(this.startDateValue)
    );
  }

  isInside(date: NgbDate) {
    return date.after(this.startDateValue) && date.before(this.startDateValue);
  }

  isRange(date: NgbDate) {
    return (
      date.equals(this.startDateValue) ||
      (this.startDateValue && date.equals(this.startDateValue)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }

  isDisabled(date: NgbDate) {
    return date.before(this.minDate);
  }

  retStartDate(index: number) {
    let day = 0;
    let month = 0;
    let year = 0;
    if (
      this.searchbox.flightsArray.at(index).get('departingD')?.value != null
    ) {
      year = new Date(
        this.searchbox.flightsArray.at(index).get('departingD')?.value,
      ).getFullYear();
      month =
        new Date(
          this.searchbox.flightsArray.at(index).get('departingD')?.value,
        ).getMonth() + 1;
      day = Number(
        this.searchbox.flightsArray
          .at(index)
          .get('departingD')
          ?.value.toString()
          .split(' ')[2],
      );

      return (this.startDateValue = { year: year, month: month, day: day });
    } else {
      this.searchbox.flightsArray
        .at(index)
        .get('departingD')
        ?.setValue(this.calendar.getToday());
      return (this.startDateValue = this.calendar.getToday());
    }
  }

  showDate() {
    this.showDatePicker = true;
  }

  closeOneWay() {
    if (this.isBrowser) {
      this.oneWayCalenderTrigger.nativeElement.click();
    }
  }

  showMobileDate(index: number) {
    this.router.navigate([`/searchboxMob/${index}`]);
  }

  showTravellers() {
    this.showDatePicker = false;
  }

  getTotalPassenger() {
    let adult = this.searchbox.searchFlight?.get('passengers.adults')?.value;
    let child = this.searchbox.searchFlight?.get('passengers.child')?.value;
    let infant = this.searchbox.searchFlight?.get('passengers.infant')?.value;
    return this.searchbox.getTotalPassengers(adult, child, infant);
  }

  onCitySearch(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const searchTerm = inputElement.value.trim();

    if (searchTerm) {
      this.isSearching = true;
      this.searchInput$.next(searchTerm);
    } else {
      this.isSearching = false;
      this.isLoading = false;
      this.sharedService.cities = this.getRecommendedAirports();
    }
  }

  onDateSelection(date: NgbDate) {
    this.searchbox.searchFlight.get('returnDate')?.setValue('');
    this.searchbox.flightsArray
      .at(0)
      .get('departingD')
      ?.setValue(new Date(date.year, date.month - 1, date.day));
    this.showDatePicker = false;
  }

  removeInput(inputType: string) {
    if (inputType == 'depart') {
      (<FormArray>this.searchbox.searchFlight?.get('Flights'))
        .at(0)
        .get('departing')
        ?.reset();
    } else {
      (<FormArray>this.searchbox.searchFlight?.get('Flights'))
        .at(0)
        .get('landing')
        ?.reset();
    }
    this.searchbox.searchFlight.updateValueAndValidity();
  }

  submit() {
    this.lang =
      this.translate.currentLang != null ? this.translate.currentLang : 'en'; // Get language
    this.currency = this.homePageService.selectedCurrency.Currency_Code; // Get currency from homepage service

    // Call submit function from searchbox service
    this.resultLink = this.searchbox.onSubmit(
      this.lang,
      // this.currency,
      'EGP',
      this.homePageService.pointOfSale
        ? this.homePageService.pointOfSale.country!
        : 'EG',
      1,
      ',',
      this.sharedAirlineService.preferredAirlineIatacode,
    );

    // Type guard to check if resultLink is of type ResultLinkObject
    if (this.isResultLinkObject(this.resultLink)) {
      // Loop through resultLink object for validation messages
      Object.entries(this.resultLink).forEach(([key, value]) => {
        if (value.enMsg) {
          this.tinyAlert(this.lang === 'en' ? value.enMsg : value.arMsg);
        }
      });
      this.searchbox.searchFlight.updateValueAndValidity();
    } else if (typeof this.resultLink === 'string' && this.resultLink) {
      // Check if form is valid before proceeding
      if (this.searchbox.searchFlight.valid) {
        // Store form data using StorageService
        this.storageService.setItem(
          'form',
          JSON.stringify(this.searchbox.searchFlight.value),
        );
        this.sharedService.saveSelectedAirportsInStorage();

        // Construct external URL
        const externalBase = 'https://flight.abousamratravel.com/flightResult/';
        const splittedLink = this.resultLink.toString().split('/');
        splittedLink.length = splittedLink.length - 1;
        const externalUrl = externalBase + splittedLink.join('/') + '/all';

        // Redirect to external site
        if (this.isBrowser) {
          window.location.href =
            externalUrl +
            '?form=' +
            JSON.stringify(this.searchbox.searchFlight.value);
        }
      } else {
        this.searchbox.searchFlight.markAllAsTouched();
      }
    } else {
      console.error('Unexpected type for resultLink:', this.resultLink);
    }
  }

  // Type guard to check if resultLink is of type ResultLinkObject
  private isResultLinkObject(
    resultLink: unknown,
  ): resultLink is ResultLinkObject {
    return (
      typeof resultLink === 'object' &&
      resultLink !== null &&
      'adult' in resultLink &&
      'child' in resultLink &&
      'infant' in resultLink &&
      'retDate' in resultLink &&
      'depDate' in resultLink
    );
  }

  tinyAlert(message: any) {
    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: message,
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    if (this.isBrowser) {
      this.screenWidth = window.innerWidth;
    }
  }

  changeAdultValue(action: string) {
    if (this.searchbox.searchFlight?.get('passengers.adults')?.value >= 9) {
      if (action == 'increase') {
        this.searchbox.searchFlight?.get('passengers.adults')?.setValue(9);
        this.adultValid = false;
      } else {
        this.searchbox.searchFlight
          ?.get('passengers.adults')
          ?.setValue(
            this.searchbox.searchFlight?.get('passengers.adults')?.value - 1,
          );
        this.adultValid = true;
      }
    } else if (
      this.searchbox.searchFlight?.get('passengers.adults')?.value <= 1
    ) {
      if (action == 'increase') {
        this.searchbox.searchFlight
          ?.get('passengers.adults')
          ?.setValue(
            this.searchbox.searchFlight?.get('passengers.adults')?.value + 1,
          );
        this.adultValid = true;
      } else {
        this.searchbox.searchFlight?.get('passengers.adults')?.setValue(1);
      }
    } else {
      this.adultValid = true;
      if (action == 'increase') {
        this.searchbox.searchFlight
          ?.get('passengers.adults')
          ?.setValue(
            this.searchbox.searchFlight?.get('passengers.adults')?.value + 1,
          );
      } else {
        this.searchbox.searchFlight
          ?.get('passengers.adults')
          ?.setValue(
            this.searchbox.searchFlight?.get('passengers.adults')?.value - 1,
          );
      }
    }
  }

  changeChildValue(action: string) {
    if (action == 'increase') {
      this.searchbox.searchFlight
        ?.get('passengers.child')
        ?.setValue(
          this.searchbox.searchFlight?.get('passengers.child')?.value + 1,
        );
      this.childValid = true;
      if (this.searchbox.searchFlight?.get('passengers.child')?.value >= 8) {
        this.searchbox.searchFlight?.get('passengers.child')?.setValue(8);
        this.childValid = false;
      }
    } else {
      this.searchbox.searchFlight
        ?.get('passengers.child')
        ?.setValue(
          this.searchbox.searchFlight?.get('passengers.child')?.value - 1,
        );
      this.childValid = true;
      if (this.searchbox.searchFlight?.get('passengers.child')?.value <= 0) {
        this.searchbox.searchFlight?.get('passengers.child')?.setValue(0);
        this.childValid = true;
      }
    }
  }

  changeInfantValue(action: string) {
    let adultValue =
      this.searchbox.searchFlight?.get('passengers.adults')?.value;
    if (action == 'increase') {
      this.searchbox.searchFlight
        ?.get('passengers.infant')
        ?.setValue(
          this.searchbox.searchFlight?.get('passengers.infant')?.value + 1,
        );
      this.infantValid = true;
      let infantValue =
        this.searchbox.searchFlight?.get('passengers.infant')?.value;
      if (infantValue > 4) {
        this.searchbox.searchFlight?.get('passengers.infant')?.setValue(4);
        this.infantValid = false;
      }
      if (infantValue > adultValue) {
        this.searchbox.searchFlight
          ?.get('passengers.infant')
          ?.setValue(adultValue);
        this.infantValid = false;
      }
    } else {
      this.searchbox.searchFlight
        ?.get('passengers.infant')
        ?.setValue(
          this.searchbox.searchFlight?.get('passengers.infant')?.value - 1,
        );
      this.infantValid = false;
      if (this.searchbox.searchFlight?.get('passengers.infant')?.value <= 0) {
        this.searchbox.searchFlight?.get('passengers.infant')?.setValue(0);
        this.infantValid = true;
      }
    }
  }

  stopMenuClosing(event: any) {
    event.stopPropagation();
  }

  InFlightResult(): boolean {
    const currentUrl = this.router.url;
    return currentUrl.includes('flightResult');
  }

  openDepartAirport(depart: TemplateRef<any>) {
    this.searchbox.flightsArray.at(0).get('departing')?.setValue('');
    this.modalService.open(depart, { fullscreen: true });
    if (this.isBrowser) {
      setTimeout(() => {
        document.getElementById('departInput')?.focus();
      }, 300);
    }
  }

  onSelectLandingCity(city: IAirPortTranslated) {
    this.sharedService.onSelectLandingAirports(city, 0);
  }

  onSelectDepartingCity(city: IAirPortTranslated) {
    this.sharedService.onSelectDepartingAirports(city, 0);
  }

  assignCountriesForMobileD(
    departCountry: any,
    index: number,
    city: IAirPortTranslated,
  ) {
    if (this.isBrowser) {
      const mobileInput = this.mobileIssuedCountryDepart.nativeElement;

      this.sharedService.onSelectDepartingAirports(city, 0);

      if (mobileInput) {
        mobileInput.value = departCountry;
        this.searchbox.flightsArray
          .at(index)
          .get('departing')
          ?.setValue(departCountry);
      }
      this.modalService.dismissAll();
    }
  }

  onSearchInputChange(event: any) {
    const inputValue = (event.target as HTMLInputElement)?.value || '';
    this.isSearching = inputValue.trim().length > 0;
  }

  openLandingAirport(landing: TemplateRef<any>) {
    this.searchbox.flightsArray.at(0).get('landing')?.setValue('');
    this.modalService.open(landing, { fullscreen: true });
    if (this.isBrowser) {
      setTimeout(() => {
        document.getElementById('landingInput')?.focus();
      }, 300);
    }
  }

  assignCountriesForMobileA(
    landingCountry: any,
    index: number,
    city: IAirPortTranslated,
  ) {
    if (this.isBrowser) {
      const mobileInput = this.mobileIssuedCountryLanding.nativeElement;

      this.sharedService.onSelectLandingAirports(city, 0);

      if (mobileInput) {
        mobileInput.value = landingCountry;
        this.searchbox.flightsArray
          .at(index)
          .get('landing')
          ?.setValue(landingCountry);
      }
      this.modalService.dismissAll();
    }
  }

  getRecommendedAirports(): IAirPortTranslated[] {
    return this.sharedService.initialRecommendedAirports;
  }
}
